/**
 * Enumeration of the video types
 */
export enum VideoType {
    /**
     * The camera video type.
     */
    CAMERA = 'camera',

    /**
     * The desktop video type.
     */
    DESKTOP = 'desktop'
}
